import { useEffect, useRef } from 'react';
import { Box, Button, Container, Grid, Sheet, Typography } from '@mui/joy';
import ChatBubble2 from '../../../components/module/Chat/Bubble/ChatBubble2';
import { FadeIn } from './FadeIn';

const CHAT_PARTNER = {
    id: 201,
    firstName: 'Анастасия',
    lastName: 'Морозова',
    verified: true,
    avatar: `${process.env.REACT_APP_URL}/img/welcome/28.jpg`,
};

const DEMO_MESSAGES = [
    { id: 'm1', fromMe: false, content: 'Привет! Ты уже видела новый Аквариум?', created_at: '2026-06-12T10:02:00Z' },
    { id: 'm2', fromMe: true, content: 'Да, вчера скачала. Выглядит прикольно', created_at: '2026-06-12T10:05:00Z', checkStatus: 3 },
    { id: 'm3', fromMe: true, content: '😍', created_at: '2026-06-12T10:05:00Z', checkStatus: 3 },
    { id: 'm4', fromMe: false, content: 'Вот-вот! И звонки прямо из чата работают', created_at: '2026-06-12T10:12:00Z' },
    { id: 'm5', fromMe: true, content: 'Давай созвонимся вечером, покажу новые стикеры ❤️', created_at: '2026-06-12T10:12:00Z', checkStatus: 3 },
    { id: 'm6', fromMe: false, content: 'Договорились! 🙌', created_at: '2026-06-12T10:13:00Z' },
];

function DemoChat() {
    const ref = useRef(null);

    useEffect(() => {
        const root = ref.current;
        if (!root) return;

        root.inert = true;
        root.querySelectorAll('a, button, input, textarea, select, [tabindex]')
            .forEach((el) => { el.setAttribute('tabindex', '-1'); });
    });

    return (
        <Sheet
            ref={ref}
            variant="soft"
            sx={{
                p: { xs: 2, md: 3 },
                borderRadius: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                background: 'none !important',
                cursor: 'default',
                pointerEvents: 'none !important',
                '& *': { cursor: 'default !important' },
            }}
        >
            {DEMO_MESSAGES.map((m) => (
                <ChatBubble2
                    key={m.id}
                    id={m.id}
                    fromMe={m.fromMe}
                    content={m.content}
                    created_at={m.created_at}
                    checkStatus={m.checkStatus}
                    isGroup={!m.fromMe}
                    senderUser={m.fromMe ? null : CHAT_PARTNER}
                />
            ))}
        </Sheet>
    );
}

export function MessengerSection() {
    return (
        <Container maxWidth="lg">
            <Box sx={{ my: { md: 12, xs: 6 } }}>
                <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center" direction={{ xs: 'column-reverse', md: 'row' }}>
                    <Grid xs={12} md={6}>
                        <FadeIn delay={0.15} y={40}>
                            <DemoChat />
                        </FadeIn>
                    </Grid>
                    <Grid xs={12} md={6}>
                        <FadeIn>
                            <Typography
                                level="h2"
                                sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: 2 }}
                            >
                                Общение без границ<br />между устройствами
                            </Typography>
                            <Typography level="body-lg" sx={{ color: 'text.secondary', mb: 3 }}>
                                Чаты синхронизируются между веб-версией и мобильным
                                приложением. Стикеры, вложения и звонки работают везде
                                одинаково. Просто продолжайте разговор там, где вам удобно.
                            </Typography>
                            <Button
                                size="lg"
                                variant="solid"
                                component="a"
                                href="https://aquarium.org.ru/auth"
                                sx={{ borderRadius: '999px', px: 4, fontWeight: 700, textDecoration: 'none !important' }}
                            >
                                Начать общаться
                            </Button>
                        </FadeIn>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}
